<script setup lang="ts">
import { computed } from 'vue'

import { camelKey } from '../service/actionLabels'
import { statusTone } from '../service/actionStatus'

import { useI18n } from '@/shared/i18n'
import { Badge } from '@/shared/ui'

const props = defineProps<{ status: string }>()

const { t, te } = useI18n()

// A status the backend adds after this build must still render as a word, not a raw key.
const label = computed(() => {
  const key = `platformActions.status.${camelKey(props.status)}`
  return te(key) ? t(key) : t('platformActions.status.unknown')
})
</script>

<template>
  <Badge :tone="statusTone(props.status)" size="sm">{{ label }}</Badge>
</template>
